import './modal-challenge-records.scss';
import Avatar from '../avatar/avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose, faChevronLeft, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useState, useRef, useEffect } from 'react';
import LocalStorage from '../../services/local-storage';
import IndividualChallengeService from '../../services/individual-challenge-service';
import { TEAM, SESSION, ASSETS } from '../../constants';
import UtilsService from '../../services/utils-service';
import ChallengeStatus from '../challenge-status/challenge-status'

export default function ModalChallengeRecords(props) {

    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));
    const recordsElement = useRef(null);
    const [isOpenDetail, setIsOpenDetail] = useState(false);
    const [isLoadingList, setIsLoadingList] = useState(true);
    const [hasMore, setHasMore] = useState(true);
    const [recordsList, setRecordsList] = useState([]);
    const [page, setPage] = useState(0);
    const [dataModalChallenge, setDataModalChallenge] = useState(null);
    
    useEffect(() => {
        getChallengeRecords();
    }, [page])

    useEffect(() => {
        let observerRefValue = null; 

        const handleInfiniteScroll = () => {
            const scrollTop = recordsElement.current.scrollTop;
            const scrollHeight = recordsElement.current.scrollHeight;
            const clientHeight = recordsElement.current.clientHeight;
            if (scrollTop + clientHeight >= scrollHeight - 5 && !isLoadingList && hasMore) {
                setIsLoadingList(true)
                setPage(page+1)
            }
        }

        if (recordsElement.current) {
            observerRefValue = recordsElement.current; // <-- save ref value
            observerRefValue.addEventListener('scroll', handleInfiniteScroll);
        }

        return () => {
            if(observerRefValue) {
                observerRefValue.removeEventListener('scroll', handleInfiniteScroll)
            }
        }

    }, [recordsElement.current, isLoadingList, hasMore])


    const getChallengeRecords = async () => {
        const response = await IndividualChallengeService.getChallengeRecords(session._id, team.area._id, page);
        if(response.length) {
            setRecordsList([...recordsList, ...response]);
        } else {
            setHasMore(false);
        }
        
        setIsLoadingList(false)
    }

    const handleModalChallengeStatus = async (challenge) => {
        const response = await IndividualChallengeService.getChallengeStatus(session._id, team.area._id, challenge.oponente._id, challenge._id );

        let status = 'lost';
        if(response.retoActual.ganador === session._id) {
            status = 'won';
        } 

        setDataModalChallenge({...response, status });
        setIsOpenDetail(true);
    }

    const closeDetailChallenge = () => {
        setDataModalChallenge(null);
        setIsOpenDetail(false)
    }



    return (
        <>
            <div className='main' ref={recordsElement}>

                <div className='flex items-center'>
                    <div className='heading-h6 grow'>Challenge records</div>
                    <div>
                        <button className='btn-close ' onClick={props.onClose}>
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                </div>

                <div>
                    <table>
                        <tbody>
                            {
                                recordsList.map((record) => (
                                    <tr key={record._id}>
                                        <td className='text-left separator-right'>
                                            <div className='flex items-center'>
                                                <Avatar className='mx-auto clean !w-[40px] !h-[40px]' image={`${ASSETS.AVATAR_PLAYER}${record.oponente.avatar}`} />
                                                <div className='ml-[14px] grow'>
                                                    <p className='font-medium'>{UtilsService.capitalize(record.oponente.nombre, record.oponente.apellidoPaterno)}</p>
                                                    <p className='font-medium text-[12px] text-secundary'>{UtilsService.formatDate(record.date, 'DD/MM/YY HH:mm')}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className='text-center separator-right'>
                                            <p className='heading-h5 px-[24px]'>{record.score.oponente} : {record.score.jugador}</p>
                                        </td>
                                        <td className='text-center'>
                                            <p className='ml-[16px]'>You</p>
                                        </td>
                                        <td className='text-right'>
                                            <p className='font-bold text-[10px] underline text-link-active cursor-pointer' onClick={() => handleModalChallengeStatus(record)}>VIEW DETAILS</p>
                                        </td>
                                    </tr>
                                ))
                            }
                            {isLoadingList && 
                                <tr>
                                    <td colSpan={4} className='text-center'>
                                        <FontAwesomeIcon icon={faSpinner} spin={true} />
                                    </td>
                                </tr>
                            }
                            
                        </tbody>
                    </table>
                </div>

            </div>
            <div className={'pushed ' + (isOpenDetail ? ' open ' : ' ') + (dataModalChallenge && dataModalChallenge.status === 'won'? ' won ': ' ')}>

                <div className='flex items-center'>
                    <div>
                        <button className='btn-close ' onClick={closeDetailChallenge}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                    </div>
                </div>

                {dataModalChallenge && <ChallengeStatus hideBtnDone={true} data={dataModalChallenge}/> }

            </div>
        </>
    )

}
